module.exports = __webpack_public_path__ + "static/media/student35.2d56140e.png";